export default __webpack_public_path__ + "static/image4-e186fddd4f05d7fc84fcb1eeea1b2180.jpg";